
import First from '../components/welcome/first.js'; 
function App() {
   
  return (
    <>
      <First />
    </>
  );
}

export default App;
